import { useReferralHistoryContext } from '../../../contexts/ReferralHistoryProvider';
import { AssociateReferral, Referral } from '../../../types/referral';

const ReferralClientNameDiv = ({
  referral,
}: {
  referral: Referral | AssociateReferral;
}) => {
  // integration of context hooks here
  const { setReferral, setShowReferralDetailsModal } =
    useReferralHistoryContext();

  // rendering referral client name div component here
  return (
    <div
      onClick={() => {
        setShowReferralDetailsModal(true);
        setReferral(referral);
      }}
      className='text-base-light-blue font-medium cursor-pointer hover:opacity-70 active:scale-95 duration-300'
    >
      <p>{referral.client_full_name}</p>
    </div>
  );
};

export default ReferralClientNameDiv;
